import { render } from "./ClientCreate.vue?vue&type=template&id=453e58c7"
import script from "./ClientCreate.vue?vue&type=script&lang=js"
export * from "./ClientCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__